import { StorageManager } from 'src/app/common/storage-manager.class';
import { FincaReaRequest, ReaModalModel } from 'src/app/models/fincas/rea.model';

/**
 * Builds backend payloads for the REA import modal.
 */
export class ReaImportPayloadBuilder {
  private static readonly reaCodeRegex = /^ES\d{12}$/;

  public static build(
    data: ReaModalModel,
    selectedRea: string,
    operationType: 'import' | 'check',
    allowMissingRea = false,
  ): FincaReaRequest | null {
    const idCliente = data.id_cliente;
    const rawCodigoRea = String(selectedRea || data.codigo_REA || '').trim();
    const codigoRea = this.isValidReaCode(rawCodigoRea) ? rawCodigoRea : '';
    const nif = String(data.titular_nif ?? '').trim();
    const nombreFinca = String(data.nombre_finca ?? '').trim();

    if (!nif || !nombreFinca) {
      return null;
    }

    if (operationType === 'import' && codigoRea === '' && !allowMissingRea) {
      return null;
    }

    const user = StorageManager.getUser();

    const payload: FincaReaRequest = {
      operationType,
      autonomousCommunity: this.getAutonomousCommunity(),
      fincaName: nombreFinca,
      rea: codigoRea,
      nif,
      userId: Number(user.id),
    };

    if (idCliente != null) {
      payload.clientId = idCliente;
    }

    return payload;
  }

  public static isValidReaCode(reaCode: string): boolean {
    return this.reaCodeRegex.test(reaCode);
  }

  private static getAutonomousCommunity(): string {
    const user = StorageManager.getUser();

    return String(user.codigo_ine ?? '').trim();
  }
}